import { ApolloLink } from 'apollo-link';

import { fg } from '@confluence/feature-gating';

export const AttachExtensionsLink = new ApolloLink((operation, forward) => {
	if (
		operation.variables &&
		operation.variables.__extensions &&
		fg('confluence_enable_agg_subscription_link_replay')
	) {
		operation.setContext({ extensions: operation.variables.__extensions });
		// remove the property since it's not an actual valid variable
		delete operation.variables.__extensions;
	}
	return forward(operation);
});
